import { formatarDataBr } from './dataBr';

// Mensagem que vai pronta no WhatsApp do gestor ao clicar na coluna Gestor.
// Limite de saída: carregamento da manhã sai até as 14:00 do mesmo dia; o da tarde, até as 05:00 do dia seguinte.

const HORA_LIMITE_MANHA = '14:00';
const HORA_LIMITE_TARDE = '05:00';

const diaMes = data => formatarDataBr(data).slice(0, 5);

// "05:00" -> "5:00", como a operação escreve.
const horaCurta = hora => {
  const partes = /^(\d{1,2}):(\d{2})/.exec(String(hora || ''));
  return partes ? `${Number(partes[1])}:${partes[2]}` : '';
};

const somarUmDia = data => {
  const partes = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(data || ''));
  if (!partes) return '';
  const dia = new Date(Date.UTC(Number(partes[1]), Number(partes[2]) - 1, Number(partes[3]) + 1));
  return dia.toISOString().slice(0, 10);
};

// Manhã pela hora de início do carregamento; sem hora, pelo turno (1º turno = manhã).
const carregamentoDaManha = registro => {
  const partes = /^(\d{1,2}):/.exec(String(registro.inicio_carregamento || ''));
  if (partes) return Number(partes[1]) < 12;
  return registro.turno === 1 || registro.turno === 'primeiro';
};

export const calcularLimiteSaida = registro => {
  const dia = String(registro.data_programacao || registro.saida_cdh || '').slice(0, 10);
  if (!dia) return '';
  return carregamentoDaManha(registro)
    ? `${diaMes(dia)} às ${HORA_LIMITE_MANHA}`
    : `${diaMes(somarUmDia(dia))} às ${HORA_LIMITE_TARDE}`;
};

// Cavalo + carretas, pela frota (sem frota, a placa identifica o veículo).
export const frotasDoConjunto = registro => {
  const veiculos = [
    registro.numero_frota || registro.placa_cavalo,
    registro.frota_carreta_1 || registro.placa_carreta_1,
    registro.frota_carreta_2 || registro.placa_carreta_2,
    registro.frota_carreta_3 || registro.placa_carreta_3
  ].map(valor => String(valor || '').trim()).filter(Boolean);
  return [...new Set(veiculos)];
};

export const montarMensagemGestor = registro => {
  const frotas = frotasDoConjunto(registro);
  const destino = [
    [registro.filial_codigo, registro.filial_nome].filter(valor => valor !== null && valor !== undefined && String(valor).trim() !== '').join(' - '),
    registro.uf ? `(${registro.uf})` : ''
  ].filter(Boolean).join(' ');
  const diaCarregamento = String(registro.data_programacao || registro.saida_cdh || '').slice(0, 10);
  const carregamento = [diaMes(diaCarregamento), horaCurta(registro.inicio_carregamento)].filter(Boolean).join(' ');

  return [
    'HAVAN',
    frotas.length ? `NOVA PROGRAMAÇÃO DA FROTA ${frotas.join(', ')}` : 'NOVA PROGRAMAÇÃO',
    '',
    `Carga: ${registro.numero_carga || registro.ct || '-'}`,
    `Destino: ${destino || '-'}`,
    `Carregamento: ${carregamento || '-'}`,
    `Entrega: ${formatarDataBr(registro.chegada_loja) || '-'}`,
    '',
    `Limite de saída: ${calcularLimiteSaida(registro) || '-'}`
  ].join('\n');
};
